// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OdooTickets_ReplyResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for adding a reply to a ticket
 *
 * Response envelope:
 * {
 *   "success": true,
 *   "dados": {
 *     "message_id": 456,
 *     "message": "Resposta enviada com sucesso"
 *   },
 *   "error": null
 * }
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface OdooTickets_ReplyResponseDados {
message_id: number
message: string
}

export type OdooTickets_ReplyResponse = ApiResponse<OdooTickets_ReplyResponseDados>;

registerResponseContract('OdooTickets_ReplyResponse', {
  message_id: { type: 'number',  required: true },
  message:    { type: 'string',  required: true },
})
